<template>
  <!--  todo change the active dashboard depends on user authenticate -->
  <dashboard-staff></dashboard-staff>
</template>

<script>
import {mapGetters} from 'vuex';
import DashboardStaff from './dashboard/staff/index';

export default {
  name: 'Dashboard',

  components : {
    'dashboard-staff' : DashboardStaff
  },

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {
    ...mapGetters([
        'authUser',
        'authFormData'
    ])
  },

  /** mounted **/
  mounted() {
    // console.log('This is user',this.authUser)
    // console.log('This is form data',this.authFormData)
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped>

</style>
